import src from "IMAGE";
export default { src, width: 1244, height: 170, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAgZLiMJHDUvCR87OwohP0YKIkFQCiNDWAojRF0KI0ReTVUFbBngI4sAAAAASUVORK5CYII="};
